<template>
    <div class="handout-filter-main">
        <!-- 筛选项 -->
        <el-row :gutter="10" class="filter-row" ref="filters" id="filters">
            <el-col :span="rowcol" class="filter-item" v-if="filterOption.year">
                <label class="label">学年</label>
                <el-select v-model="formData.year" size="small" placeholder="请选择" @change="filterChange" clearable>
                    <el-option v-for="item in filterInfo.years" :value="item.id" :key="item.id" :label="item.name"></el-option>
                </el-select>
            </el-col>
            <el-col :span="rowcol" class="filter-item" v-if="filterOption.term">
                <label class="label">学期</label>
                <el-select v-model="formData.term" size="small" placeholder="请选择" @change="filterChange" clearable>
                    <el-option v-for="item in filterInfo.terms" :value="item.id" :key="item.id" :label="item.name"></el-option>
                </el-select>
            </el-col>
            <el-col :span="rowcol" class="filter-item" v-if="filterOption.grade">
                <label class="label">年级</label>
                <el-select v-model="formData.grade" size="small" placeholder="请选择" @change="filterChange" clearable>
                    <el-option v-for="item in filterInfo.grade" :value="item.id+''" :key="item.id" :label="item.name"></el-option>
                </el-select>
            </el-col>
            <el-col :span="rowcol" class="filter-item" v-if="filterOption.version">
                <label class="label">版本</label>
                <el-select v-model="formData.version" size="small" placeholder="请选择" @change="filterChange" clearable>
                    <el-option v-for="item in filterInfo.version" :value="item.id" :key="item.id" :label="item.name"></el-option>
                </el-select>
            </el-col>
            <el-col :span="rowcol" class="filter-item" v-if="filterOption.area">
                <label class="label">地区</label>
                <el-select v-model="formData.area" size="small" placeholder="请选择" @change="filterChange" clearable>
                    <el-option v-for="item in filterInfo.areas" :value="item.id" :key="item.id" :label="item.name"></el-option>
                </el-select>
            </el-col>
            <el-col :span="rowcol" class="filter-item" v-if="filterOption.plan">
                <label class="label">讲次</label>
                <el-select v-model="formData.plan" size="small" placeholder="请选择" @change="filterChange" clearable>
                    <el-option v-for="item in filterInfo.plan" :value="item.id" :key="item.id" :label="item.name"></el-option>
                </el-select>
            </el-col>
            <el-col :span="rowcol" class="filter-item" v-if="filterOption.is_freeze">
                <label class="label">冻结</label>
                <el-select v-model="formData.is_freeze" size="small" placeholder="请选择" @change="filterChange" clearable>
                    <el-option v-for="item in filterInfo.freeze" :value="item.id" :key="item.id" :label="item.name"></el-option>
                </el-select>
            </el-col>
            <el-col :span="rowcol" class="filter-item" v-if="filterOption.status">
                <label class="label">状态</label>
                <el-select v-model="formData.status" size="small" placeholder="请选择" @change="filterChange" clearable>
                    <el-option v-for="item in filterInfo.status" :value="item.id" :key="item.id" :label="item.name"></el-option>
                </el-select>
            </el-col>
            <el-col :span="rowcol" class="filter-item" v-if="filterOption.type">
                <label class="label">类型</label>
                <el-select v-model="formData.type" size="small" placeholder="请选择" @change="filterChange" clearable>
                    <el-option v-for="item in filterInfo.type" :value="item.id" :key="item.id" :label="item.name"></el-option>
                </el-select>
            </el-col>
        </el-row>
        <div class="filter-search">
            <el-input placeholder="请输入内容" v-model="formData.search_text" class="input-with-select" clearable v-if="filterOption.search">
                <el-select v-model="formData.search_mode" slot="prepend" placeholder="请选择">
                    <el-option label="讲义id" value="1"></el-option>
                    <el-option label="讲义名称" value="2"></el-option>
                    <el-option label="创建人" value="3"></el-option>
                </el-select>
                <el-button @click="filterChange" slot="append" icon="el-icon-search"></el-button>
            </el-input>
            <button class="search-btn" @click.stop="clearData">清空筛选</button>
        </div>
    </div>
</template>

<script>
import { httpRequest } from '../../../src/utils/ajax'
export default {
    props: ['filterInfo', 'formData', 'filterOption'],
    data() {
        return {
            rowcol: 4,
            search_text: '',
            search_mode: '1'
        }
    },
    mounted() {
        this.setRowCol()
    },
    methods: {
        setRowCol() {
            this.$nextTick(el => {
                this.setWidth()
            })
        },
        setWidth() {
            let w = document.querySelector('#xes-handout-filter').offsetWidth
            if (w < 300) {
                this.rowcol = 24
            }
            if (w >= 300 && w < 600) {
                this.rowcol = 12
            }
            if (w >= 600 && w < 900) {
                this.rowcol = 8
            }
            if (w >= 900 && w < 1200) {
                this.rowcol = 6
            }
            if (w >= 1200 && w < 1500) {
                this.rowcol = 4
            }
            if (w >= 1500) {
                this.rowcol = 3
            }
        },
        filterChange() {
            this.$emit('change')
        },
        clearData() {
            this.$emit('clear')
        }
    }
}
</script>


// WEBPACK FOOTER //
// packages/handout-filter/src/filter.vue